import React from "react";
import * as R from "ramda";
import {connect} from "react-redux";
import Recaptcha from "react-google-invisible-recaptcha";
import {consultarKeyCaptcha} from "../redux/modules/seguridad/actions";

function withRecaptcha(WrappedComponent: any) {

  class WithRecaptchaSinConectar extends React.Component<any, any> {

    recaptcha: any;
    onCaptchaSuccessFunction: any;

    componentDidMount(): void {
      if (!this.props.keyRecaptcha) {
        this.props.dispatch(consultarKeyCaptcha());
      }
    }

    render() {
      return (
        // @ts-ignore
        <>

          {this.props.keyRecaptcha !== "" &&
          <Recaptcha
            ref={ref => this.recaptcha = ref}
            sitekey={this.props.keyRecaptcha}
            locale={"es"}
            onResolved={(recaptchaValue) => {
              this.onCaptchaSuccessFunction(recaptchaValue);
            }}/>
          }
          <WrappedComponent
            {...this.props}
            recaptchaValidate={this.validate}
            setOnRecaptchaSuccessFunction={this.setOnRecaptchaSuccessFunction}/>
        </>
      );
    }

    validate = () => {
      this.recaptcha.execute();
    }
      
    onCaptchaSuccess = (recaptchaValue) => {
      this.onCaptchaSuccessFunction(recaptchaValue);
    }

    setOnRecaptchaSuccessFunction = (executeOnCaptchaSuccessFunction) => {
      this.onCaptchaSuccessFunction = executeOnCaptchaSuccessFunction;
    }
  }

  const WithRecaptcha: any = connect(
    (store: any) => {
      return {
        keyRecaptcha: R.pathOr("", ["recDocInternet", "seguridad", "key"], store),
      };
    },
  )(WithRecaptchaSinConectar);

  return WithRecaptcha;
}

export default withRecaptcha;
